import { render, staticRenderFns } from "./RegionFilter.vue?vue&type=template&id=07fc5344&scoped=true&"
import script from "./RegionFilter.vue?vue&type=script&lang=js&"
export * from "./RegionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc5344",
  null
  
)

export default component.exports